module.exports = __webpack_public_path__ + "img/page3-bg-main.a2f04f3d.png";